import { initArray, noop } from "frontend/utils/fn-utils";
import { range } from "rambda";
import React from "react";
import { Rect } from "react-konva";
import { TableTitle } from "./table-title";
import consts from "shared/consts";

export const GhostTable = React.memo(
  ({
    cols,
    rows,
    initialStyle,
    cellWidth,
    cellHeight,
    borderColor = "#c8c8c8",
  }: {
    cols: number;
    rows: number;
    initialStyle?: any;
    cellWidth: number;
    cellHeight: number;
    borderColor?: string;
  }) => {
    // I'm building an array of cells, that will hold all the cells in the table, column-major order.
    // cells[0] - col 0, row 0
    // cells[1] - col 0, row 1
    // cells[2] - col 0, row 2 ... etc
    // to access cell at (row,col) use cells[col * numRows + row]
    const cells = initArray(cols * rows, () => ({
      fill: "white",
    }));

    for (const rule of initialStyle.rules) {
      if (typeof rule.row === "number" && typeof rule.col === "number") {
        cells[rule.col * rows + rule.row] = rule.style;
      } else if (typeof rule.row === "number") {
        for (let col = 0; col < cols; col++) {
          cells[col * rows + rule.row] = rule.style;
        }
      } else if (typeof rule.col === "number") {
        for (let row = 0; row < rows; row++) {
          cells[rule.col * rows + row] = rule.style;
        }
      }
    }

    return (
      <>
        <TableTitle id="" element={{ x: 0, y: 0, title: consts.DEFAULTS.NEW_TABLE_TITLE }} dispatch={noop} />
        {range(0, cols).flatMap((col) =>
          range(0, rows).map((row) => {
            return (
              <Rect
                key={`${col * rows + row}`}
                x={col * cellWidth}
                y={row * cellHeight}
                width={cellWidth}
                height={cellHeight}
                fill={cells[col * rows + row].fill}
                strokeWidth={1}
                strokeScaleEnabled={false}
                stroke={borderColor}
                listening={false}
              />
            );
          })
        )}
      </>
    );
  }
);

GhostTable.displayName = "GhostTable";
